// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"styles-module__placeholder___25L-x","bi":"styles-module__bi___2ZAv1","inputDateRangePicker":"styles-module__inputDateRangePicker___SoSI6"};